import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotToday from "./components/HotToday";
import Timeline from "./components/Timeline";
import ExposeFilter from "./components/ExposeFilter";
import People from "./components/People";
import Topics from "./components/Topics";
import Ranking from "./components/Ranking";
import Discussions from "./components/Discussions";
import Glossary from "./components/Glossary";
import Faq from "./components/Faq";
import Newsletter from "./components/Newsletter";
import Disclaimer from "./components/Disclaimer";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <HotToday />
        <Timeline />
        <ExposeFilter />
        <People />
        <Topics />
        <Ranking />
        <Discussions />
        <Glossary />
        <Faq />
        <Newsletter />
        <Disclaimer />
      </main>
      <Footer />
    </div>
  );
}